import React from "react";
import { LANDSCAPE } from "../lib/i18n";

export default function About({ t }) {
  // Duplicate ribbon items for seamless loop
  const ribbon = [...t.about.ribbon, ...t.about.ribbon];

  return (
    <section
      id="about"
      data-testid="about-section"
      className="relative border-b border-rule bg-paper"
    >
      <div
        aria-hidden
        className="absolute inset-0 opacity-[0.18]"
        style={{
          backgroundImage: `url(${LANDSCAPE})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          mixBlendMode: "multiply",
        }}
      />

      <div className="relative mx-auto max-w-[1400px] px-6 md:px-10 lg:px-16 py-20 md:py-28 grid grid-cols-1 lg:grid-cols-12 gap-12">
        <div className="lg:col-span-4">
          <div className="font-mono text-[11px] tracking-[0.22em] uppercase text-ember">
            ⌘ {t.about.kicker}
          </div>
          <h2 className="mt-4 font-serif text-4xl md:text-6xl leading-[0.98] tracking-tight">
            {t.about.title}
          </h2>
        </div>

        <div className="lg:col-span-7 lg:col-start-6 space-y-6 text-lg leading-relaxed text-ink">
          <p className="first-letter:font-serif first-letter:text-6xl first-letter:font-medium first-letter:float-left first-letter:mr-3 first-letter:leading-[0.85] first-letter:text-ember">
            {t.about.body_1}
          </p>
          <p>{t.about.body_2}</p>
          <p className="text-mist italic">{t.about.body_3}</p>
        </div>
      </div>

      {/* Marquee ribbon */}
      <div className="relative border-t border-b border-ink bg-ink text-paper py-4 overflow-hidden">
        <div className="np-marquee-track flex gap-10 whitespace-nowrap font-mono text-[13px] tracking-[0.3em] uppercase">
          {ribbon.map((r, i) => (
            <span key={i} className="flex items-center gap-10">
              <span>{r}</span>
              <span className="text-[#ffa36b]" aria-hidden="true">✦</span>
            </span>
          ))}
        </div>
      </div>
    </section>
  );
}
